import React from "react";
import { GeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useDepartment } from "../../hooks/useDepartment";
import DepartmentModule from "../../components/modules/Department/DepartmentModule";

const DepartmentPage = ({ user, isHideSideMenu }) => {
  const deptMethods = useDepartment();

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Maintenance > "}</span>
                <span className="border-b border-black">{"Departments"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Departments</h3>
            </div>

            <DepartmentModule
              user={user}
              {...deptMethods}
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={deptMethods.showMessage}
        message={deptMethods.message}
        isSuccess={deptMethods.isSuccess}
      />

      <LoadingSpinner loading={deptMethods.loading} />
    </>
  );
};

export default DepartmentPage;